<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <!-- {{ videos }} -->
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="videos"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                videos.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : videos.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <!-- <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item> -->
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th>Description.</vs-th>
        <vs-th sort-key="duration">Duration</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="">Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              <p class="sl no.">{{indextr + 1}}</p>
            </vs-td> -->
            <vs-td>
              <p class="videos-title font-medium ">
                {{ tr.videoName }}
              </p>
            </vs-td>

            <vs-td>
              <p class="videos-desc">{{ tr.videoDescription }}</p>
            </vs-td>

            <vs-td>
              <p class="videos-duration">{{ tr.derivedDuration }}</p>
            </vs-td>

            <vs-td>
              <!-- <p class="videos-status" v-if="tr.isProcessed" >{{ tr.derivedDuration }}</p> -->
              <span v-if="tr.isProcessed">Processed</span>
              <span v-else>Processing</span>
            </vs-td>

            <vs-td v-if="data[indextr].isProcessed" class="whitespace-no-wrap">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="playVideo(tr)"
              />
              <feather-icon
                icon="InfoIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="showInfo(tr)"
              />
              <!-- <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteVideo(tr)"
              /> -->
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- video in player -->
    <vs-popup
      class="holamundo"
      title="Add/Update Lesson"
      :active.sync="isVideoPopup"
    >
      <!-- <v-card-text class="text-center"> -->
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <video-player
              v-if="previewUrl"
              :key="previewUrl"
              :options="videoOptions"
            />
          </div>
        </div>
      <!-- </v-card-text> -->

      <!-- <v-spacer></v-spacer> -->
    </vs-popup>

    <!-- show info of selected video -->
    <vs-popup
      class="holamundo"
      title="Assigned Lesson info"
      :active.sync="infoDialogPopup"
    >
      <vs-table v-if="showInfoData"  :data="showInfoData">
        <template slot="thead">
          <vs-th sort-key="courseName">Course</vs-th>
          <vs-th sort-key="moduleName">Module</vs-th>
          <vs-th sort-key="lesson">Lessons</vs-th>
          <vs-th sort-key="status">Access</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
              <p class="videos-title font-medium truncate">
                {{ tr.courseinfo.title }}
              </p>
            </vs-td>

            <vs-td>
              <p class="videos-desc">{{ tr.moduleName }}</p>
            </vs-td>

            <vs-td>
              <p class="videos-desc">{{ tr.lessonName }}</p>
            </vs-td>
            <vs-td>
              <p class="videos-desc">{{ tr.isEnabled ? "Enabled": "Disabled" }}</p>
            </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import moduleVideoLibrary from '@/store/videoLibrary/moduleVideoLibrary.js'
import VideoPlayer from '@/views/components/VideoPlayer.vue'

export default {
  components: {
    VideoPlayer
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,

      //video player
      dialogVideo: false,
      previewUrl: null,
      videoOptions: {
        controls: true,
        sources: [
          {
            src: '',
            type: 'application/x-mpegURL'
          }
        ]
      },
      videoUrl: null,
      videoTitle: null,

      //shoinfo vars
      showInfoData: null,
      infoDialog: false
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    videos() {
      return this.$store.state.videoLibrary.videoLibrary
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.videos.length
    },
    isVideoPopup: {
      get() {
        return this.dialogVideo
      },
      set(val) {
        // console.log('isViseopopup set', val)
        if (!val) {
          this.dialogVideo = false
          this.previewUrl = null
          // this.videoOptions = {}
          this.videoOptions.sources[0].src = ''
        }
      }
    },
    closeVideo() {
      this.videoUrl = null
      this.videoTitle = null
      this.dialogVideo = false
    },
    infoDialogPopup: {
      get() {
        return this.infoDialog
      },
      set(val) {
        // console.log('isViseopopup set', val)
        if (!val) {
          this.infoDialog = false
          // this.previewUrl = null
          // // this.videoOptions = {}
          // this.videoOptions.sources[0].src = ''
        }
      }
    }
  },
  methods: {
    playVideo(video) {
      if (video) {
        // console.log(video, 'video')
        // this.videoUrl = video.videoUrl
        // this.videoTitle = video.title
        this.previewUrl = video.videoUrl
        this.videoOptions.sources[0].src = video.videoUrl
        this.dialogVideo = true
      } else {
        this.$showWarningToast(this, 'Preview not available')
      }
    },
    showInfo(data) {
      // console.log('showInfo data', data.lessons)
      this.showInfoData = data.lessons
      this.infoDialog = true
    },
    deleteVideo(data) {
      // console.log("delete data", data)
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Delete',
        text: `You are about to delete "${data.title}"`,
        accept: () => {
          this.showDeleteSuccess(data)
        },
        acceptText: 'Delete'
      })
    },
    showDeleteSuccess(data) {
      console.log('lesson to be deleted', data)
      this.$store
        .dispatch('courses/removeLesson', data)
        .then((response) => {
          this.$vs.notify({
            color: 'success',
            title: 'Deleted',
            text: response.data.data
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  created() {
    if (!moduleVideoLibrary.isRegistered) {
      this.$store.registerModule('videoLibrary', moduleVideoLibrary)
      moduleVideoLibrary.isRegistered = true
    }
    this.$store.dispatch('videoLibrary/fetchVideoLibrary')
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
